import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import BoxButton from './BoxButton';

import styles from '../../../styles/partials/newsletter.scss';

const propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
};

const defaultProps = {

};

class Newsletter extends Component {
    constructor(props) {
        super(props);

        this.onEmailChange = this.onEmailChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);

        this.state = {
            email: null,
            placeholder: null,
        };
    }

    onEmailChange(e) {
        const { value } = e.currentTarget;
        this.setState({
            email: value,
        });
    }

    onFormSubmit() {
        const { intl } = this.props;
        const { formatMessage } = intl;

        this.setState({
            placeholder: formatMessage({
                id: 'content.newsletter_thankyou',
                defaultMessage: 'Thank you!',
            }),
        });
    }

    render() {
        const { intl } = this.props;
        const { formatMessage } = intl;
        const { email, placeholder } = this.state;

        return (
            <div className={styles.container}>
                <form
                    action={formatMessage({
                        id: 'content.newsletter_action',
                        defaultMessage: '#',
                    })}
                    method="post"
                    onSubmit={this.onFormSubmit}
                >
                    <div className={styles.control}>
                        <div className={styles.col}>
                            <input
                                id="mce-EMAIL"
                                type="email"
                                name="EMAIL"
                                className={styles.input}
                                value={email || ''}
                                placeholder={placeholder || formatMessage({
                                    id: 'content.newsletter_placeholder',
                                    defaultMessage: 'Enter you email address...',
                                })}
                                onChange={this.onEmailChange}
                            />
                        </div>
                        <div className={styles.col}>
                            <BoxButton
                                type="submit"
                                label={{
                                    id: 'content.subscribe',
                                    defaultMessage: 'Subscribe',
                                }}
                                small
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

Newsletter.propTypes = propTypes;
Newsletter.defaultProps = defaultProps;

export default injectIntl(Newsletter);



// WEBPACK FOOTER //
// ./js/components/partials/Newsletter.jsx